import { render, staticRenderFns } from "./off_canvas_nav.vue?vue&type=template&id=4d060c3c&lang=html&"
import script from "./off_canvas_nav.vue?vue&type=script&lang=js&"
export * from "./off_canvas_nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../base-image/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports